import { premiumBuildingsPrices } from "@/config/constants";
import { formatNumber } from "@/utils/format";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class TempleBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.TEMPLE;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];

	public get description(): string {
		return super.description.replace(
			"{number}",
			formatNumber(
				this.requirements.get(ResourceType.SETTLEMENT_LEVEL)! as number,
			),
		);
	}
}

export default TempleBuildingTileEntity;
